/*
    模块组件
    ChenYN

    说明
    主页底部切换栏

    版本
    1.0

    传参
        goodsData Object : 必填 商品信息
        type String : 非必填 商品类型 默认 shop
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <demo></demo>
*/
<template>
    <div class="shop_card">
        <!-- S 卡片上半部分，图片 -->
        <div class="card_tp_shop">
            <img :src="goodsData.thumb || goodsData.avatar_frame" alt />
        </div>
        <!-- E 卡片上半部分，图片 -->

        <!-- S 卡片下半部分，信息 -->
        <div class="card_bt">
            <!-- S 卡片标题 -->
            <div class="title">
                <!-- <img v-if="vip" :src="vip" alt class="vip_img" /> -->
                <span class="van-ellipsis">{{goodsData.name}}</span>
            </div>
            <!-- E 卡片标题 -->

            <!-- S 开奖模式 -->
            <div class="draw_box" v-if="type == 'drawprize'">
                <!-- 标题 -->
                <div class="draw_tit">
                <div class="draw_tit_lt">开奖进度</div>
                <div class="draw_tit_rt">{{parseInt(progress) || 0}}%</div>
                </div>

                <!-- 进度条 -->
                <div class="step_box">
                <div class="step_bar" :style="{transform: 'translateX(' + progress + '%)'}"></div>
                </div>

                <!-- 价格 -->
                <div class="draw_price">
                <div class="deaw_price_lt">
                    <div class="icon icon_gold"></div>
                    <div>{{price}}</div>
                    <div class="draw_num">/次</div>
                </div>

                <!-- S 兑换按钮 -->
                <!-- <div class="btn_box">
                    <Button class="shop_btn">兑换</Button>
                </div>-->
                <!-- E 兑换按钮 -->
                </div>

                <!-- 时间 -->
                <div class="draw_time">
                <div>{{startTime || '0000-00-00 00:00:00'}} 开始</div>
                <div>{{endTime || '0000-00-00 00:00:00'}} 结束</div>
                </div>
            </div>
            <!-- E 开奖模式 -->

            <!-- S 积分兑换模式 -->
            <div class="price_box" v-else>
                <div class="price_tp">
                    <div class="icon"> <img v-if="goodsData.icon" :src="goodsData.icon" > </div>
                    <div class="price van-ellipsis" :class="{member_price: goodsData.price && goodsData.member_price}">{{goodsData.member_price || goodsData.price}}</div>
                    <!-- <div v-if="goodsData.member_price_icon" class="badge_img"> <img :src="goodsData.member_price_icon" /> </div> -->
                    <Button class="shop_btn">兑换</Button>
                </div>

                <!-- <del class="del_price">{{goodsData.member_price ? goodsData.price + '积分' : ''}}</del> -->
                <!-- <del class="del_price"></del> -->
                
                <!-- <div class="change_num">可兑换次数: {{goodsData.max_exchange - goodsData.redeemed || 0}} / {{goodsData.max_exchange || 0}}</div> -->

                <!-- S 兑换按钮 -->
                <!-- <div class="btn_box">
                    <Button class="shop_btn">兑换</Button>
                </div> -->
                <!-- E 兑换按钮 -->
            </div>
            <!-- E 积分兑换模式 -->
        </div>
        <!-- E 卡片下半部分，信息 -->
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import router from "@/router"
import { Button } from "vant"

export default defineComponent({
    name: 'ShopCard',
    components: { Button },
    props: {
        goodsData: {
            type: Object
        },
        type: {
            type: String,
            default: 'shop'
        }
    },
    setup(props) {
        const state = reactive({});
        const data = reactive({});
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
        }; //需要对外暴露的方法

        onMounted(() => {
        
        });

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./ShopCard.less";
</style>